import {colors, font_s_sm, font_s_xs, font_s_md, clearfix} from '@xpertdox_js/xdstyle';

export default {
  message: { // container
     width: '52%',
     marginBottom: '12px'
  },
  messageFrom: {
    float: 'right',
  },
  messageTo: {
    float: 'left',
  },

  // message header
  messageHead: {
    padding: '0 4px 4px 4px',
    opacity: .8,
    ...clearfix,
  },
  timestamp: {
    ...font_s_xs,
    float: 'right',
    marginBottom: 10,
    // maxWidth: '40%',
  },
  author: {
    ...font_s_sm,
    float: 'right',
    // maxWidth: '60%',
  },

  // message box
  messageContent: {
    background: '#fff',
    padding: '8px',
    borderRadius: '4px',
    marginBottom: '3px',
    boxShadow: 'rgba(0, 0, 0, 0.12) 0px 0.1rem 0.2rem',
    ...font_s_md,
  },
  contentFrom: {
    background: colors.xdHighlight,
    color: '#fff',
    // borderTop: '1px solid rgba(255,255,255,0.72)',
    // borderLeft: '1px solid rgba(255,255,255,0.72)',
    // borderRight: '1px solid rgba(0,0,0,0.1)',
    // borderBottom: '2px solid rgba(0,0,0,0.1)',
  },
  contentTo: {
    // borderTop: '1px solid rgba(255,255,255,0.42)',
    // borderLeft: '1px solid rgba(255,255,255,0.42)',
    // borderRight: '1px solid rgba(0,0,0,0.095)',
    // borderBottom: '2px solid rgba(0,0,0,0.095)',
  },

}
